// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Page from '../pageLayout/Page';
import UpdatePassword from '../../_common/UpdatePassword';
import { Navigate } from 'react-router-dom';

const PasswordRecovery = ({ ...props }) => {
    const {
        state: { active_user },
    } = useGlobalState();

    if (active_user.isLoggedIn) {
        return <Navigate to='/' replace />;
    }

    return (
        <Page title='Password Reset' icon='lock'>
            <UpdatePassword />
        </Page>
    );
}

export default PasswordRecovery; 